import { ArtistViewState } from "@/store/types/artistView.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import Artist from '@/models/artist';
import Artwork from '@/models/artwork';

export const state: ArtistViewState = {
    artist: new Artist(),
    artistArtworks: [],
    loading: true,
    displayingImage : new Artwork(),
    displayingBigImage: false,
};

const namespaced = true;

export const ArtistViewModule: Module<ArtistViewState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}